import React from 'react';
import InfoCircle from 'wix-ui-icons-common/InfoCircle';

export default class InfoCircleClass extends React.PureComponent {
  render() {
    return <InfoCircle size={18} />;
  }
}

InfoCircleClass.displayName = 'InfoCircleClass';
